
import React, { useEffect, useState } from "react";
// import { getBranchNames } from '../../actions/BusinessActions';
import XLSX from 'xlsx'
import moment from 'moment-jalaali'
import { Form, message, Select } from 'antd';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { InfoCircleOutlined } from '@ant-design/icons';
import { usePersistedStore } from "../../store/persisted-store";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function SalesFilter(params) {

    const { getBranchNames, business } = usePersistedStore()
    const reports = useReportsStore()
    const [fromDate, setFromDate] = useState(null);
        const [toDate, setToDate] = useState(null);
    const branchNames = business.branchNames.data;
    const branchNamesLoading = business.branchNames.loading;
    const sales = reports.sales.data.DetailReport;
    const loading = reports.sales.loading;
    const Token = business.currentBusiness.token;

    useEffect(() => {
        getBranchNames(Token);
    }, [Token])

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {

        const params = {
            fromDate: convertToMoment(fromDate),//moment(values.fromDate).format('YYYY/MM/DD'),
            toDate: convertToMoment(toDate), //moment(values.toDate).format('YYYY/MM/DD'),
            branchId: values.branch
        }
        reports.getSalesInfo({ param: params })
    }

    function downloadxlsx() {
        let data = sales;
        if (!data) return message.error('داده ای برای دانلود وجود ندارد')
        let xlsxData = data.map(d => [
            d.PersonName,
            d.UserName,
            d.PolicyOwnerNationalCode,
            d.BranchName,
            d.Premium,
            d.Payment,
            d.VoucherAmount,
            d.NotSendDiscount,
            d.NotVisitDiscount,
            d.OtherDiscountsAmount,
            d.ReturnToUser,
            d.CartToCartAmount,
            d.DurationTitle,
            d.CompanyName,
            d.Penalty,
            d.Installment === true ? 'اقساطی' : 'نقدی',
            d.CommissionAmount,
            d.BusinessWageAmount,
            d.BusinessWagePercent,
            d.TaxAmount,
            d.TrackingCode,
            d.RequestId,
            moment(d.BuyDate).format('jYYYY/jMM/jDD'),
            moment(d.IssuanceDate).format('jYYYY/jMM/jDD'),
            d.PromoterFullName,
        ])
        xlsxData.unshift(['نام بیمه گزار', 'نام کاربری', '  کد ملی بیمه گزار ', 'نام رشته', 'مبلغ حق بیمه', 'مبلغ پرداختی', 'مبلغ کد تخفیف', 'تخفیف عدم ارسال', 'تخفیف عدم بازدید', 'سایر تخفیفات', 'عودت', 'کارت به کارت', 'مدت بیمه نامه', 'نام شرکت بیمه', 'جریمه', ' روش پرداخت ', 'مبلغ کارمزد کاربر', 'مبلغ کارمزد بیزینس ', 'درصد کارمزد بیزینس', 'مبلغ مالیات', 'کد رهگیری', 'کد درخواست', 'تاریخ خرید', 'تاریخ صدور', 'نام بازاریاب'])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "bimeh[dot]com.xlsx")
    }

    return (
        <div>
            <Form
                className="sale-filter"
                initialValues={{
                    branch: params.branchId,
                    user: null,
                    fromDate: params.fromDate && moment(params.fromDate).subtract(1, 'months'),
                    toDate: params.toDate && moment(params.toDate)
                }}
                layout="inline" onFinish={onFinish}><Form.Item
                    name='branch'
                    label="رشته بیمه">
                    <Select
                        defaultValue={null}
                        loading={branchNamesLoading}
                        disabled={!branchNames?.length}
                        style={{ minWidth: 200 }}>
                        <Select.Option key="all" value={null}>همه رشته  بیمه ها</Select.Option>
                        {branchNames && branchNames.filter(name => !name.Disabled).map(name => {
                            return <Select.Option key={name.Id} value={name.Id}>{name.Title}</Select.Option>
                        })}
                    </Select>
                </Form.Item>
                <Form.Item
                    name='fromDate'
                    label='از تاریخ'>
                    <DatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item
                    name='toDate'
                    label='تا تاریخ'>
                    <DatePicker
                        value={toDate}
                        onChange={setToDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item label="" colon={false}>

                    <button
                        disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ marginRight: "10px" }}>
                        جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                    </button>
                </Form.Item>
            </Form>
            <button
                className="btn btn-success waves-effect waves-light float-left" disabled={!sales}
                onClick={downloadxlsx}
                style={{
                    position: 'relative',
                    marginRight: '10px',
                    top: '-39px',
                    left: '100px'
                }}>
                <i className="far fa-file-excel font-size-14 align-middle mr-2"></i> دریافت اکسل
            </button>
            <div className="sales-info"><InfoCircleOutlined /><strong>توجه: </strong>در فیلد مبلغ پرداختی مقادیر عودتی از مبلغ پرداختی کسر گردیده است و مبلغ نهایی پرداخت لحاظ شده است.
                مبنای محاسبه کارمزد مبلغ پرداختی می‌باشد.
            </div>
        </div>
    )
}